import { AllHTMLAttributes, ChangeEvent, forwardRef, useState } from 'react';
import { Box, FormHelperText, TextField, styled } from '@mui/material';
import clsx from 'clsx';
import { Control, Controller, ControllerProps } from 'react-hook-form';
import { ErrorFormField } from '../types';

export const StyleTextField = styled(TextField)({
  '& textarea:focus': {
    'box-shadow': 'none',
  },
  '& input:focus': {
    'box-shadow': 'none',
  },
  '& input': {
    fontWeight: 600,
  },
});

type CustomTextFieldProps = AllHTMLAttributes<HTMLDivElement> &
  ErrorFormField & {
    [key: string]: any;
  };

const CustomTextField = forwardRef((props: CustomTextFieldProps, ref) => {
  const { className, error, errMessage, value = '', onChange, ...extraProps } = props as any;

  return (
    <Box className={clsx('flex flex-col', className)}>
      <StyleTextField {...extraProps} ref={ref} error={error} value={value} onChange={onChange} />
      {error && (
        <FormHelperText className="mt-1" error={error}>
          {errMessage}
        </FormHelperText>
      )}
    </Box>
  );
});

type ControlledProps = Omit<ControllerProps, 'control' | 'render'> &
  CustomTextFieldProps & {
    control: Control<any>;
  };

export const TextFieldControlled = forwardRef(({ control, name, ...props }: ControlledProps, ref) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return <CustomTextField {...props} ref={ref} value={value} onChange={onChange} error={!!error} errMessage={error?.message} />;
      }}
    />
  );
});

export default CustomTextField;
